/**
 * @file 产品全景
 * @author FengGuang(fengguang01@baidu.com)
 */
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'location-origin';
import React from 'react';
import ReactDOM from 'react-dom';

import Overview from './Overview';

import './style.less';



ReactDOM.render(<Overview />, document.getElementById('root'));


